/* global ppms */
import { parse } from 'Models/utils/App';
import { dispatch } from 'Models/utils/event-bus';

export default function acceptCookiesMessage (element) {
    const defaultSettings = {
        cookieType: 'analytics',
        cookiesAcceptedEvent: false,
    };
    const customSettings = element.dataset.settings ? JSON.parse(element.dataset.settings) : {};
    const settings = { ...defaultSettings, ...customSettings };

    const elements = {
        acceptButton: element.querySelector('.js-accept-cookies-message__accept'),
    };

    const states = {
        messageVisible: 'is-cookie-message-visible',
    };

    function init () {
        checkAcceptedCookies();
    }

    function addListeners () {
        elements.acceptButton.addEventListener('click', acceptClickHandler);
    }

    function acceptClickHandler () {
        acceptCookies();
    }

    function checkAcceptedCookies () {
        if (ppms !== undefined) {
            ppms.cm.api('getComplianceSettings', settingsSuccessCallback);
        }
    }

    function settingsSuccessCallback (data) {
        if (data.consents && data.consents[settings.cookieType] && data.consents[settings.cookieType].status === 1) {
            showForm();
        } else {
            hideForm();
            addListeners();
        }
    }

    function acceptCookies (data) {
        if (ppms !== undefined) {
            const complianceSettings = {
                consents: {},
            };
            complianceSettings.consents[settings.cookieType] = { status: 1 };
            ppms.cm.api('setComplianceSettings', complianceSettings, acceptSuccessCallback);
        }
    }

    function acceptSuccessCallback (data) {
        showForm();
    }

    function showForm () {
        element.classList.remove(states.messageVisible);
        parse(element, true);

        if (settings.cookiesAcceptedEvent) {
            setTimeout(() => {
                dispatch(settings.cookiesAcceptedEvent);
            }, 100);
        }
    }

    function hideForm () {
        element.classList.add(states.messageVisible);
    }

    init();
}
